(function () {
  var MONTHS_SHORT_RO = ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Noi', 'Dec'];
  var MONTHS_LONG_RO = ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'];

  function addBusinessDays(date, days) {
    var result = new Date(date);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return result;
  }

  function formatShortRo(date) {
    return date.getDate() + ' ' + MONTHS_SHORT_RO[date.getMonth()];
  }

  function updateGenericDeliveryDates() {
    var nodes = document.querySelectorAll('[data-dynamic-date="true"][data-text]');
    var today = new Date();

    nodes.forEach(function (node) {
      var text = node.getAttribute('data-text');
      if (!text) return;

      var minDays = parseInt(node.getAttribute('data-min-days'), 10) || 0;
      var maxDays = parseInt(node.getAttribute('data-max-days'), 10) || 0;

      var startDate = minDays === 0 ? today : addBusinessDays(today, minDays);
      var endDate = maxDays === 0 ? today : addBusinessDays(today, maxDays);

      node.innerHTML = text
        .replace('[start_date]', formatShortRo(startDate))
        .replace('[end_date]', formatShortRo(endDate));
    });
  }

  /**
   * "Comenzi acum / Procesăm comanda / Livrare estimată" — computed from the
   * current calendar day in Europe/Bucharest, independent of the visitor's
   * device timezone/clock settings.
   */

  function getBucharestToday() {
    var formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Bucharest',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    var year, month, day;

    formatter.formatToParts(new Date()).forEach(function (part) {
      if (part.type === 'year') year = parseInt(part.value, 10);
      if (part.type === 'month') month = parseInt(part.value, 10);
      if (part.type === 'day') day = parseInt(part.value, 10);
    });

    return new Date(Date.UTC(year, month - 1, day));
  }

  function addUTCDays(date, days) {
    var result = new Date(date.getTime());
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  }

  function formatDateOnly(date, style) {
    if (style === 'short') {
      return date.getUTCDate() + ' ' + MONTHS_SHORT_RO[date.getUTCMonth()] + '.';
    }
    return date.getUTCDate() + ' ' + MONTHS_LONG_RO[date.getUTCMonth()];
  }

  function getShippingCopy(today) {
    var dayOfWeek = today.getUTCDay(); // 0 = Sunday ... 6 = Saturday
    var deliveredDate;

    if (dayOfWeek >= 1 && dayOfWeek <= 4) {
      // Monday - Thursday: delivered next day
      deliveredDate = addUTCDays(today, 1);
    } else if (dayOfWeek === 5) {
      // Friday: delivered Monday
      deliveredDate = addUTCDays(today, 3);
    } else if (dayOfWeek === 6) {
      // Saturday: delivered Tuesday
      deliveredDate = addUTCDays(today, 3);
    } else {
      // Sunday: delivered Tuesday
      deliveredDate = addUTCDays(today, 2);
    }

    var processingDate = today;
    if (dayOfWeek === 6) {
      processingDate = addUTCDays(today, 2);
    } else if (dayOfWeek === 0) {
      processingDate = addUTCDays(today, 1);
    }

    return {
      placedDate: today,
      processingDate: processingDate,
      deliveredDate: deliveredDate,
      placedText: formatDateOnly(today),
      deliveredText: formatDateOnly(deliveredDate)
    };
  }

  function updateShippingRoles() {
    var placedNodes = document.querySelectorAll('[data-shipping-role="placed"]');
    var deliveredNodes = document.querySelectorAll('[data-shipping-role="delivered"]');
    var processingNodes = document.querySelectorAll('[data-shipping-role="processing"]');

    if (!placedNodes.length && !deliveredNodes.length && !processingNodes.length) {
      return;
    }

    var copy = getShippingCopy(getBucharestToday());

    function styleOf(node) {
      var holder = node.closest ? node.closest('[data-date-style]') : null;
      return holder ? holder.getAttribute('data-date-style') : 'long';
    }
    placedNodes.forEach(function (node) {
      node.textContent = formatDateOnly(copy.placedDate, styleOf(node));
    });
    deliveredNodes.forEach(function (node) {
      node.textContent = formatDateOnly(copy.deliveredDate, styleOf(node));
    });
    processingNodes.forEach(function (node) {
      node.textContent = formatDateOnly(copy.processingDate, styleOf(node));
    });
  }

  window.addEventListener('load', function () {
    updateGenericDeliveryDates();
    updateShippingRoles();
  });
})();
